/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { UserInviteRequest, UserInviteResponse } from '../types/UserInvite'

/**
 * POST /users/invite
 * @see backend/nexus/modules/Organisation/Http/Controllers/UserController.php UserController::invite
 */
export async function userInvite(
	data: UserInviteRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<UserInviteResponse>> {
	return axiosInstance.post('/users/invite', data, config)
}
